import {CircularProgress, ListItemText} from '@material-ui/core'
import {makeStyles} from '@material-ui/core/styles'
import Autocomplete from '@material-ui/lab/Autocomplete'
import {SuggestObject} from '@yandex-taxi/js-integration-api'
import {isGeoObject} from '@yandex-taxi/react-integration-api'
import React from 'react'

import {GridHeader} from '../grid-header'
import {Input, Props as InputProps} from '../input'
import {theme} from '../theme'

type Props = {
  placeholder?: string
  part?: string
  geoObject?: SuggestObject
  suggest?: SuggestObject[]
  loading?: boolean
  onChange: (geoObject: SuggestObject) => void
  onInputChange: (part: string) => void
  onInputBlur?: InputProps['onBlur']
  onInputFocus?: InputProps['onFocus']
  helperText?: React.ReactNode
  className?: string
}

const useClasses = makeStyles({
  noOptions: {
    color: theme.palette.common.black,
    textAlign: 'center',
  },
  paper: {
    boxShadow: '0 0 32px rgba(0, 0, 0, 0.1)',
  },
  option: {
    alignItems: 'flex-start',
  },
})
const empty: SuggestObject[] = []
const noOptionsText = (
  <>
    Мы пока не доставяем по этому адресу,
    <br />
    но быстро доставляем по городу.
  </>
)
const renderOption = (option: SuggestObject): JSX.Element => (
  <>
    <ListItemText primary={option.title.text} secondary={option.subtitle.text} />
    {option.distance?.text && <GridHeader item>{option.distance.text}</GridHeader>}
  </>
)

// todo педелать с Autocomplete на Input + Menu, Autocomplete не очень подходит и слишком избыточный
const Suggest: React.FC<Props> = props => {
  const {
    helperText,
    part = '',
    geoObject = null,
    suggest = empty,
    loading = false,
    placeholder,
    onInputChange,
    onInputBlur,
    onInputFocus,
    onChange,
    className,
  } = props
  const classes = useClasses()

  return (
    <Autocomplete
      classes={classes}
      filterOptions={() => suggest}
      getOptionLabel={option => option.title.text}
      inputValue={part}
      noOptionsText={noOptionsText}
      onChange={(event, nextGeoObject) => {
        if (isGeoObject(nextGeoObject)) {
          onChange(nextGeoObject)
        }
      }}
      options={suggest}
      renderInput={params => (
        <Input
          className={className}
          error={!!helperText}
          fullWidth={params.fullWidth}
          helperText={helperText}
          inputProps={{
            ...params.inputProps,
            autoComplete: '__disable-autocomplete',
          }}
          InputProps={{
            endAdornment: loading ? <CircularProgress color="secondary" size={20} /> : undefined,
            ref: params.InputProps.ref,
          }}
          onBlur={onInputBlur}
          onChange={event => {
            onInputChange(event.target.value)
          }}
          onFocus={onInputFocus}
          placeholder={placeholder}
        />
      )}
      renderOption={renderOption}
      value={geoObject}
      // микро хак чтобы не было фильтрации
      autoComplete
      freeSolo
      openOnFocus
    />
  )
}

export default Suggest
